import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { IUserCardData, IUserCardAction } from 'models/user/usercard';
import { IUserPreferences } from 'models/user/userpreferences';
import { UserActivitySettingsDropdownMenu } from 'containers/Common/DropdownMenus';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { getRecentActivities, resetRecentActivitiesData, getUserCard } from 'modules/user/usercard';
import { RecentActivityType } from 'models';
import { getArticleCard } from 'redux/modules/magazine/article/articlecard';
import { IArticleCardAction } from 'models/magazine/article/articlecard';
import { getProductCard } from 'redux/modules/product/productcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { getWardrobeItemCard } from 'redux/modules/wardrobe/wardrobeitemcard';
import { getOutfitCard } from 'redux/modules/outfit/outfitcard';
import { IOutfitCardDataAction } from 'models/outfit/outfitcard';
require('./style.css');

interface IProps {
	userCardData?: IUserCardData;
	userPreferences?: IUserPreferences;
	isMyProfile: boolean;

	/* function props */
	t?: (key: string, options?: any) => string;
	getRecentActivities?: (userId: string, isFirstLoad: boolean) => IUserCardAction;
	resetRecentActivitiesData?: () => IUserCardAction;
	getArticleCard?: (id: string) => IArticleCardAction;
	getProductCard?: (id: string) => IProductCardDataAction;
	getUserCard?: (id: string) => IUserCardAction;
	getWardrobeItemCard?: (id: string) => IUserCardAction;
	getOutfitCard?: (id: string) => IOutfitCardDataAction;
}

interface IUserActivityItemCardList extends IItemCardList {
	userPicture?: string;
	activityLikesVisible?: boolean;
	activityCommentsVisible?: boolean;
	activityStylesVisible?: boolean;
	activityWishlistVisible?: boolean;
	activityArticlesVisible?: boolean;
	activityFollowsVisible?: boolean;
	activityWardrobeItemsVisible?: boolean;
	activityOutfitsVisible?: boolean;
}

@connect(
	(state: IStore) => ({
		userCardData: state.usercard,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getRecentActivities: (userId: string, isFirstLoad: boolean) => dispatch(getRecentActivities(userId, isFirstLoad)),
		resetRecentActivitiesData: () => dispatch(resetRecentActivitiesData()),
		getArticleCard: (id: string) => dispatch(getArticleCard(id)),
		getProductCard: (id: string) => dispatch(getProductCard(id)),
		getUserCard: (id: string) => dispatch(getUserCard(id)),
		getWardrobeItemCard: (id: string) => dispatch(getWardrobeItemCard(id)),
		getOutfitCard: (id: string) => dispatch(getOutfitCard(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserActivity extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetRecentActivitiesData();
	}

	public loadMoreData() {
		if (this.props.userCardData.selectedTab === c.USERCARD_TAB_ACTIVITY) {
			this.props.getRecentActivities(this.props.userCardData.usercard.id, false);
		}
	}

	private goToCard(id: string, activityType: RecentActivityType) {
		switch (activityType) {
			case RecentActivityType.AddArticle:
				this.props.getArticleCard(id);
				break;

			case RecentActivityType.AddWardrobeItem:
				this.props.getWardrobeItemCard(id);
				break;

			case RecentActivityType.AddWishlistProduct:
				this.props.getProductCard(id);
				break;

			case RecentActivityType.AddWishlistWardrobeItem:
				this.props.getWardrobeItemCard(id);
				break;

			case RecentActivityType.FollowUser:
				this.props.getUserCard(id);
				break;

			case RecentActivityType.LikeArticle:
				this.props.getArticleCard(id);
				break;

			case RecentActivityType.LikeProduct:
				this.props.getProductCard(id);
				break;

			case RecentActivityType.AddOutfit:
				this.props.getOutfitCard(id);
				break;

			default:
				break;
		}
	}

	public render() {
		const { t, isMyProfile } = this.props;
		const { picture } = this.props.userCardData.usercard;
		const { recentActivities, recentActivitiesPage } = this.props.userCardData;
		const {
			activityArticlesVisible,
			activityCommentsVisible,
			activityFollowsVisible,
			activityLikesVisible,
			activityStylesVisible,
			activityWardrobeItemsVisible,
			activityWishlistVisible,
			activityOutfitsVisible,
		} = this.props.userPreferences;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: recentActivities.length,
			next: this.loadMoreData,
			hasMore: recentActivitiesPage.totalItems > recentActivities.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IUserActivityItemCardList = {
			items: recentActivities,
			itemType: c.NODE_TYPE_USER_RECENT_ACTIVITY_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			userPicture: picture,
			activityArticlesVisible,
			activityCommentsVisible,
			activityFollowsVisible,
			activityLikesVisible,
			activityStylesVisible,
			activityWardrobeItemsVisible,
			activityWishlistVisible,
			activityOutfitsVisible,
			isMyProfile,
			goToCard: this.goToCard,
		};

		return (
			<div className="userActivityComponent">
				<div className="activityTopWrapper">
					<div className="titleWrapperActivity">
						<span className="titleActivityPossition">{t('User_UserCard_Tabs_Activity_Title')}</span>
					</div>
					{isMyProfile ? (
						<div className="wrapperSettingsActivity">
							<UserActivitySettingsDropdownMenu />
						</div>
					) : null}
				</div>
				<ItemCardList {...listProps} />
			</div>
		);
	}
}

export { UserActivity };
